export const GET_STATISTICS_PRIVATE_LEAGUES = "GET_STATISTICS_PRIVATE_LEAGUES";
export const CLEAR_FILTERS_PRIVATE_LEAGUES = "CLEAR_FILTERS_PRIVATE_LEAGUES";